import { createFileRoute } from '@tanstack/react-router';
import { FunnelShell } from '../components/shell/FunnelShell.tsx';

export const Route = createFileRoute('/_funnel')({
  component: FunnelShell,
});
